import * as React from 'react';
export const bankraykatSvg = React.forwardRef(function bankraykatSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1071B9',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm19.793 14.608 5.104 8.518-2.681 4.649-2.29-3.767h-9.85l-2.819-4.727h9.81l2.726-4.673Zm5.425-9.6-2.11 3.839L28 17.41l-2.674 4.808-4.914-8.578h-5.365l4.795-8.633h5.376ZM18.932 5l-4.975 8.576 2.637 4.63H6.595L4 13.708h4.402L13.496 5h5.436Z',
      fill: '#E06F27',
    }),
  );
});
bankraykatSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bankraykat = {
  category: 'brand',
  colorable: false,
  name: 'bankraykat',
  svg: bankraykatSvg,
};
